import { render, staticRenderFns } from "./mini-auth-trigger.vue?vue&type=template&id=810d2cfe&scoped=true"
import script from "./mini-auth-trigger.vue?vue&type=script&lang=js"
export * from "./mini-auth-trigger.vue?vue&type=script&lang=js"
import style0 from "./mini-auth-trigger.vue?vue&type=style&index=0&id=810d2cfe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.24_coffee-script@1.12.7_css-loader@6.11.0_@rspack+co_4m24pxnsikzpownn6ubod5ipge/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810d2cfe",
  null
  
)

export default component.exports